<template>
    <section>
        <div class="row">
            <div class="col-xs-12">
                <h4><b>Sec. Mun. de Saúde de Vitória da Conquista</b></h4>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <h4><b>Unidade Solicitante:</b></h4>
                <h4>{{ $props.solicitacao.itens[0].contrato_procedimento.contrato.unidade.nome }}</h4>
            </div>
        </div>
        <div class="row" align="center">
            <div class="col-xs-12">
                <h4><b>AUTORIZAÇÃO DE PROCEDIMENTO</b></h4>
            </div>
        </div>
        <h4 v-show="$props.solicitacao.situacao == SITUACAO_SOLICITACAO.CANCELADA"><b>Cancelada por: </b>&nbsp;{{ nomeProfissionalCancelar($props.solicitacao) }}</h4>

        <h1 class="codigo-maior" align="center">{{ $props.solicitacao.id | formatarCodigo }}</h1>

        <barcode marginBottom="0" align="center" displayValue="false" :value="$props.solicitacao.id.toString().padStart(10, '0')" format="code39">
            Erro no código de barras.
        </barcode>

        <div class="row">
            <div class="col-xs-12">
                <h4><b>Tipo de consulta</b></h4>
                <p>{{ $props.solicitacao.itens[0].tipo_consulta | tipoConsulta }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <h4><b>Paciente </b></h4>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <p>
                    <b class="maior">Nome: {{ $props.solicitacao.paciente.nome.toUpperCase() }}</b>
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <p>Nascimento: {{ $props.solicitacao.paciente.data_nascimento | dataFormatada }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <p>Sexo: {{ $props.solicitacao.paciente.sexo | sexo }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <p>Telefone: {{ $props.solicitacao.paciente.telefone }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <p>Município: {{ $props.solicitacao.paciente.cidade.nome }}</p>
            </div>
        </div>

        <div class="row" v-show="$props.solicitacao.situacao == SITUACAO_SOLICITACAO.EM_REGULACAO">
            <div class="col-xs-12">
                <h4>
                    <b align="justify">
                        AGUARDAR ANÁLISE DO MÉDICO REGULADOR E DISPONIBILIDADE DE VAGA.<br />
                        ESTARÁ DISPONÍVEL NO PERÍODO DE {{ $props.solicitacao.created_at | dataFormatada }} ATÉ {{ adicionarDiasData($props.solicitacao.created_at, 2) | dataFormatada }}.
                    </b>
                </h4>
            </div>
        </div>

        <br />

        <div v-show="$props.solicitacao.diagnosticos.lenght > 0" class="row">
            <div class="col-xs-12">
                <h4><b>Diagnóstico(s)</b></h4>
                <ul>
                    <li style="margin-left: -23px" v-for="(item, index) in $props.solicitacao.diagnosticos" :key="index">{{ item.nome }}</li>
                </ul>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <h4><b>Qt. - Procedimentos(s)</b></h4>
                <ul>
                    <li style="margin-left: -23px" v-for="(item, index) in $props.solicitacao.itens" :key="index">
                        <!-- {{ item.quantidade }} - {{ item.contrato_procedimento.procedimento.nome }} -->
                        {{item.quantidade}} - {{item.contrato_procedimento.procedimento.codigo.replace(/[^\d]+/g,'')}} - {{item.contrato_procedimento.procedimento.nome}}
                        <div class="row" v-if="item.contrato_procedimento_atendimento">
                            <div class="col-sm-12">
                                <p v-show="(item.contrato_procedimento_atendimento.contrato_procedimento.preparo && $props.solicitacao.situacao == SITUACAO_SOLICITACAO.MARCADA) || $props.solicitacao.situacao == SITUACAO_SOLICITACAO.CONFIRMADA"><b>PREPARO (S):</b></p>
                                <p align="justify" v-show="(item.contrato_procedimento_atendimento.contrato_procedimento.preparo && $props.solicitacao.situacao == SITUACAO_SOLICITACAO.MARCADA) || $props.solicitacao.situacao == SITUACAO_SOLICITACAO.CONFIRMADA"><strong>{{ item.contrato_procedimento_atendimento.contrato_procedimento.preparo ? item.contrato_procedimento_atendimento.contrato_procedimento.preparo.descricao : "" }}</strong></p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <span v-if="($props.solicitacao.itens[0].contrato_procedimento_atendimento || $props.solicitacao.itens[0].contrato_subgrupo_atendimento) && ($props.solicitacao.situacao == SITUACAO_SOLICITACAO.MARCADA || $props.solicitacao.situacao == SITUACAO_SOLICITACAO.CONFIRMADA)" class="row">
            <div class="row">
                <div class="col-xs-12">
                    <h4><b>Realizar</b></h4>
                    <p v-if="$props.solicitacao.itens[0].contrato_procedimento_atendimento">
                        <b class="maior">{{ $props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.nome }}</b>
                    </p>
                    <p v-if="$props.solicitacao.itens[0].contrato_subgrupo_atendimento">
                        <b class="maior">{{ $props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.nome }}</b>
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <b v-if="$props.solicitacao.itens[0].contrato_procedimento_atendimento"
                        ><p class="maior">{{ $props.solicitacao.itens[0].contrato_procedimento_atendimento.data_atendimento | dataFormatada }}, {{ $props.solicitacao.itens[0].contrato_procedimento_atendimento.data_atendimento | diaDaSemana }}, às {{ $props.solicitacao.itens[0].contrato_procedimento_atendimento.hora_inicial | horaFormatada }}hrs</p></b
                    >
                    <b v-if="$props.solicitacao.itens[0].contrato_subgrupo_atendimento"
                        ><p class="maior">{{ $props.solicitacao.itens[0].contrato_subgrupo_atendimento.data_atendimento | dataFormatada }}, {{ $props.solicitacao.itens[0].contrato_subgrupo_atendimento.data_atendimento | diaDaSemana }}, às {{ $props.solicitacao.itens[0].contrato_subgrupo_atendimento.hora_inicial | horaFormatada }}hrs</p></b
                    >
                </div>
            </div>

            <div v-if="$props.solicitacao.tipo_atendimento != null">
                <div class="row">
                    <div class="col-xs-12">
                        <p>
                            Endereço: {{ $props.solicitacao.itens[0].contrato_procedimento_atendimento ? $props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.endereco : $props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.endereco }},
                            {{ $props.solicitacao.itens[0].contrato_procedimento_atendimento ? $props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.numero_endereco : $props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.numero_endereco }}
                        </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-6">
                        <p>Bairro: {{ $props.solicitacao.itens[0].contrato_procedimento_atendimento ? $props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.bairro : $props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.bairro }}</p>
                    </div>
                    <div class="col-xs-6">
                        <p>CEP: {{ $props.solicitacao.itens[0].contrato_procedimento_atendimento ? $props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.cep : $props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.cep }}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-6">
                        <p>Município: {{ $props.solicitacao.itens[0].contrato_procedimento_atendimento ? $props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.cidade.nome : $props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.cidade.nome }}</p>
                    </div>
                    <div class="col-xs-6">
                        <p>Estado: {{ $props.solicitacao.itens[0].contrato_procedimento_atendimento ? $props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.cidade.uf.uf : $props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.cidade.uf.uf }}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-6">
                        <p>Ponto de Referência: {{ $props.solicitacao.itens[0].contrato_procedimento_atendimento ? $props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.ponto_referencia : $props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.ponto_referencia }}</p>
                    </div>
                    <div class="col-xs-6">
                        <p>Telefone: {{ $props.solicitacao.itens[0].contrato_procedimento_atendimento ? $props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.telefone : $props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.telefone }}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-12">
                        <p>Complemento: {{ $props.solicitacao.itens[0].contrato_procedimento_atendimento ? $props.solicitacao.itens[0].contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.complemento_endereco : $props.solicitacao.itens[0].contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.complemento_endereco }}</p>
                    </div>
                </div>
            </div>
        </span>

        <div v-show="$props.solicitacao.situacao == SITUACAO_SOLICITACAO.CANCELADA" class="row">
            <div class="col-xs-12">
                <h4><b>Justificativa</b></h4>
                <p>{{ justificativaCancelamento($props.solicitacao) }}</p>
            </div>
        </div>

        <div v-show="$props.solicitacao.tipo_atendimento !== 1 && ($props.solicitacao.situacao == SITUACAO_SOLICITACAO.MARCADA || $props.solicitacao.situacao == SITUACAO_SOLICITACAO.CONFIRMADA)" class="row">
            <div class="col-xs-12">
                <h4><b>Profissional Realizador</b></h4>
                <p>{{ $props.solicitacao.itens[0].contrato_procedimento_atendimento ? $props.solicitacao.itens[0].contrato_procedimento_atendimento.profissional.nome : "" }}</p>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <h4><b>Profissional Solicitante</b></h4>
                <p>{{ $props.solicitacao.profissional.nome }}</p>
            </div>
        </div>

        <div v-if="$props.solicitacao.situacao == SITUACAO_SOLICITACAO.REALIZADA" class="row">
            <div class="col-xs-12">
                <h4><b>Data da realização</b></h4>
                <p>{{ $props.solicitacao.itens[0].contrato_procedimento_atendimento ? $props.solicitacao.itens[0].contrato_procedimento_atendimento.data_atendimento : $props.solicitacao.itens[0].contrato_subgrupo_atendimento.data_atendimento | dataFormatada }}</p>
            </div>
        </div>


        <div class="row">
			<div class="col-xs-12">
				<h4><b>Marcador</b></h4>
				<p>{{$props.solicitacao.usuario.name}}</p>
			</div>
		</div>

        <div class="row">
            <div class="col-xs-12">
                <h4><b>Informações</b></h4>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <p align="justify">
                    CASO VOCÊ NÃO PUDER COMPARECER À CONSULTA MÉDICA OU PROCEDIMENTO AGENDADO, FAVOR LIGAR 48 HORAS ANTES PARA DEVOLVER/CANCELAR A VAGA.
                </p>
                <p align="justify">
                    PARA CANCELAMENTOS DE VAGAS, PROCURE SUA UNIDADE DE MARCAÇÃO.
                </p>
                <p align="justify">
                    PARA REALIZAÇÃO DESSE PROCEDIMENTO, É NECESSÁRIO ESTAR COM OS DOCUMENTOS PESSOAIS, SOLICITAÇÃO DE PROCEDIMENTO E TAMBÉM O CARTÃO SUS.
                </p>
                <p align="justify">
                    EXAMES PERDIDOS SÓ SERÃO REMARCADOS APÓS 30 DIAS.
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <p style="font-size: 10px;"></p>
            </div>
        </div>
    </section>
</template>

<script>
// import axios from 'axios' // Cliente para requisição http
import VueBarcode from "vue-barcode";
import { SITUACAO_SOLICITACAO } from "@/constants";
export default {
    props: ["solicitacao"],
    computed: {
        SITUACAO_SOLICITACAO: function() {
            return SITUACAO_SOLICITACAO;
        }
    },
    data: () => ({}),
    mounted() {},
    methods: {
        nomeProfissionalCancelar(solicitacao) {
            var text = "";
            solicitacao.solicitacao_historicos.forEach(element => {
                if (element.situacao == this.SITUACAO_SOLICITACAO.CANCELADA) {
                    text = element.usuario.name;
                }
            });
            return text;
        },
        justificativaCancelamento(solicitacao) {
            var text = "";
            solicitacao.solicitacao_historicos.forEach(element => {
                if (element.situacao == this.SITUACAO_SOLICITACAO.CANCELADA) {
                    text = element.observacao;
                }
            });
            return text;
        },
        adicionarDiasData(data, dias) {
            var entrada = new Date(data);
            var dataVenc = new Date(entrada.getTime() + dias * 24 * 60 * 60 * 1000);
            return dataVenc;
        }
    },
    watch: {},
    components: {
        barcode: VueBarcode
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// solicitacaoBoleto.vue?88ba9492